import {
  LinkContainer,
  LinkIconContainer,
} from "../../screens/ProductVIP/components/NamePriceActions/InformationLinks/styles"

import { CreditCard } from "../../icons"
import { HEADER_HEIGHT } from "../../theme"
import { LinkButton } from "../LinkButton"
import { Trans } from "@lingui/macro"
import { useScreenSize } from "../../hooks"
import { useStoreState } from "../../providers/StoreProvider"

type PaymentMethodsLinkProps = {
  hasDiscounts?: boolean
}

export function PaymentMethodsLink({
  hasDiscounts = false,
}: PaymentMethodsLinkProps) {
  const { isDesktop } = useScreenSize()
  const [state] = useStoreState()

  const handleClick = () => {
    const { sticky } = state.config.header

    const buttonTarget = document.getElementById(
      hasDiscounts ? "custom-payment-methods" : "payment-methods"
    )

    if (buttonTarget) {
      const headerOffset = !sticky
        ? 0
        : isDesktop
        ? HEADER_HEIGHT.DESKTOP
        : HEADER_HEIGHT.MOBILE

      const elementPosition = buttonTarget.getBoundingClientRect().top

      const offsetPosition = elementPosition - headerOffset

      window.scrollBy({
        top: offsetPosition,
        behavior: "smooth",
      })
    }
  }

  return (
    <LinkContainer>
      {!hasDiscounts && (
        <LinkIconContainer>
          <CreditCard />
        </LinkIconContainer>
      )}
      <LinkButton
        data-testid="product-vip-payment-methods-link"
        onClick={handleClick}
      >
        {hasDiscounts ? (
          <Trans>Ver más descuentos</Trans>
        ) : (
          <Trans>Ver medios de pago</Trans>
        )}
      </LinkButton>
    </LinkContainer>
  )
}
